import User from './model.js'
import { deepGet, addToCollection } from '../shared/helper'

export default {
  namespaced: true,
  state: {
    users: [],
    filteredCollection: [],
    current: new User()
  },
  getters: {
    getCollection: state => state.users,
    getFilteredCollection: state => state.filteredCollection,
    getById: state => (id) => state.users.find(user => user.id === id),
    getCurrent: state => state.current
  },
  actions: {
    getCollection({ commit, getters, state }, payload) {
      return this.dispatch('get', {
        path: 'v1/users?include=roles',
        ...payload
      }).then((res) => {

        const data = deepGet(res, 'body.data')
        if (data) {

          const models = data.map((user) => {
            commit('addUserToCollection', { userData: user })
            return getters.getById(user.id)
          })

          commit('addUserToFilteredCollection', models)

          return { data: models, meta: res.body.meta }
        }
        return res
      })
    },
    create({ commit, getters }, model) {
      return this.dispatch('post', {
        path: 'v1/users?include=roles',
        data: model.getJSON()
      }).then((res) => {

        commit('addUserToCollection', { userData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    update({ commit, getters }, model) {
      return this.dispatch('put', {
        path: 'v1/users/' + model.id + '?include=roles',
        data: model.getJSON()
      }).then((res) => {

        commit('addUserToCollection', { userData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    delete({ commit }, id) {
      return this.dispatch('del', {
        path: 'v1/users/' + id
      }).then((res) => {

        commit('removeUserFromCollection', id)

        return res
      })
    },
    getRoles(store) {
      return this.dispatch('get', {
        path: 'v1/roles'
      })
    },
    getMe(store) {
      return this.dispatch('get', {
        path: 'v1/users/me?include=roles'
      })
    },
    signIn(store, payload) {
      return this.dispatch('post', {
        path: 'v1/users/signIn?include=roles',
        data: payload
      })
    },
    signOut(store) {
      return this.dispatch('post', {
        path: 'v1/users/signOut'
      })
    }
  },
  mutations: {
    addUserToCollection(state, { userData, opts }) {
      addToCollection(this, state.users, userData, User, opts)
    },
    addUserToFilteredCollection(state, data) {
      state.filteredCollection = state.filteredCollection.concat(data)
    },
    removeUserFromCollection(state, userId) {
      const index = state.users.findIndex(el => el.id === userId)

      if (index === -1) {
        console.warn(`Could not find/delete user ${userId}`)
        return
      }

      state.users.splice(index, 1)
    },
    clearCollection(state) {
      state.users = []
    },
    clearFilteredCollection(state) {
      state.filteredCollection = []
    },
    updateCurrent(state, user) {
      state.current = user
    },
    resetCurrent(state) {
      state.current = new User()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/user/store.js